import React from "react";
import { motion } from "framer-motion";

const rows = [
  { label: "Legal entity", value: "Dental 360 & Associates" },
  { label: "Number of locations", value: "24" },
  { label: "Number of providers", value: "55" },
  { label: "Number of staff logins", value: "150" },
  {
    label: "Practice management systems",
    value: "Ascend (12 locations), Fuse (10 locations), Dentrix (1 location)",
  },
  {
    label: "Specialties",
    value: "General, Pediatric, Orthodontics, Oral surgery",
  },
  { label: "States operated", value: "Illinois, Wisconsin, Indiana" },
];

const Asha360PracticeSnapshotSlide = () => {
  return (
    <div className="h-full w-full bg-[#f8fafc] flex items-center justify-center p-6 xl:p-10 relative overflow-hidden font-sans">
      {/* Ambient gradient blurs (kept for visual consistency with the rest of the deck) */}
      <div
        className="absolute top-[-200px] right-[-100px] w-[700px] h-[700px] rounded-full blur-[120px] opacity-30 pointer-events-none"
        style={{ background: "linear-gradient(135deg, #93c5fd 0%, #c4b5fd 50%, #fbcfe8 100%)" }}
      />
      <div
        className="absolute bottom-[-200px] left-[-100px] w-[600px] h-[600px] rounded-full blur-[120px] opacity-25 pointer-events-none"
        style={{ background: "linear-gradient(135deg, #a5f3fc 0%, #93c5fd 50%, #c4b5fd 100%)" }}
      />
      <div className="absolute inset-0 bg-[radial-gradient(#cbd5e1_0.8px,transparent_0.8px)] [background-size:28px_28px] opacity-40 pointer-events-none" />

      <div className="w-full max-w-[960px] z-10 relative">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="mb-8"
        >
          <p className="text-[11px] font-bold uppercase tracking-[0.18em] text-slate-500 mb-2">
            Practice snapshot
          </p>
          <h2 className="text-3xl lg:text-[40px] font-bold text-slate-900 tracking-tight leading-tight">
            About{" "}
            <span className="bg-gradient-to-r from-blue-600 to-indigo-600 bg-clip-text text-transparent">
              Dental 360 &amp; Associates.
            </span>
          </h2>
          <p className="text-[14px] text-slate-600 mt-2">
            The information your team shared with us, which this quote is
            built against.
          </p>
        </motion.div>

        {/* Plain text table */}
        <motion.dl
          initial={{ opacity: 0, y: 12 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.1 }}
          className="border-t border-slate-200"
        >
          {rows.map((r) => (
            <div
              key={r.label}
              className="grid grid-cols-[260px_1fr] gap-6 py-3.5 border-b border-slate-200"
            >
              <dt className="text-[13.5px] text-slate-500 font-medium">
                {r.label}
              </dt>
              <dd className="text-[14.5px] text-slate-900 font-medium">
                {r.value}
              </dd>
            </div>
          ))}
        </motion.dl>
      </div>
    </div>
  );
};

export default Asha360PracticeSnapshotSlide;
